import React from 'react';
import MessageBubble from './MessageBubble';
import DaySeparator from './DaySeparator';
import { parseUTCToLocal, formatToLocalTime } from '../../utils/dateUtils';
import { renderTextWithLinks } from '../../utils/linkify';
import './chat.css';

const sameDay = (a, b) => !!a && !!b && a.toDateString() === b.toDateString();

/*
 * Presentational message flow shared by the individual and group chats.
 * The parent owns the scrollable container, the data, and all transport;
 * this component only lays out day separators, runs, and bubbles.
 *
 * `pending` is the local echo of in-flight sends: [{ id, text }].
 */
const ChatMessages = ({ messages, isMine, senderLabel, senderIcon, variantFor, renderBody, pending = [] }) => (
    <div className="wt-messages">
        {messages.map((message, index) => {
            const prev = messages[index - 1];
            const date = parseUTCToLocal(message.created_at);
            const prevDate = prev ? parseUTCToLocal(prev.created_at) : null;
            const newDay = !prev || !sameDay(date, prevDate);
            const showMeta = newDay || !prev || prev.sender !== message.sender;
            const mine = isMine(message);

            return (
                <React.Fragment key={message.message_id || index}>
                    {newDay && date && <DaySeparator date={date} />}
                    <MessageBubble
                        variant={mine ? 'mine' : variantFor(message)}
                        showMeta={showMeta}
                        senderLabel={mine ? null : senderLabel(message)}
                        senderIcon={mine || !senderIcon ? null : senderIcon(message)}
                        time={formatToLocalTime(message.created_at)}
                    >
                        {renderBody(message)}
                    </MessageBubble>
                </React.Fragment>
            );
        })}
        {pending.map((item) => (
            <MessageBubble key={item.id} variant="mine" showMeta pending>
                {renderTextWithLinks(item.text)}
            </MessageBubble>
        ))}
    </div>
);

export default ChatMessages;
